import React from 'react';
import ScrollReveal from '../components/ScrollReveal';
import { useLanguage } from '../contexts/LanguageContext';

const AboutUs: React.FC = () => {
    const { tString } = useLanguage();
    
    return (
        <section
            className="w-screen flex items-center justify-center  px-16 py-12"
            style={{
                backgroundColor: '#f7f8f9',
                backgroundImage: `
                    radial-gradient(ellipse 80% 60% at center, transparent 0%, #f7f8f9 80%),
                    url('/images/pattern.png')
                `,
                backgroundSize: 'auto',
                backgroundRepeat: 'repeat',
            }}
        >
            <div id="aboutus" className="scroll-mt-40 grid grid-cols-1 md:grid-cols-2 gap-0 max-w-5xl w-full my-8">
                <ScrollReveal direction="left" delay={0.2} duration={0.8}>
                    <div className="flex flex-col justify-center text-left mr-10 mb-10">
                        <h2 className="text-4xl font-bold text-[#081833] mb-4">
                            {tString('about.title')}<span className="text-[#29519F]">.</span>
                        </h2>
                        <p className="text-lg text-[#556987]">
                            {tString('about.description')}
                        </p>
                    </div>
                </ScrollReveal>
                <ScrollReveal direction="right" delay={0.4} duration={0.8}>
                    <div className="flex justify-center md:justify-end">
                        <img
                            src="/images/aboutUs.png"
                            alt="Trucks"
                            className="rounded-xl shadow-lg w-[400px] h-[300px] object-cover"
                        />
                    </div>
                </ScrollReveal>
            </div>
        </section>
    );
};

export default AboutUs;
